import { toastApiError } from "./apiError"

const toCamelCase = key =>
  String(key || "")
    .replace(/\[(\d+)\]/g, "_$1")
    .split(/[._]/)
    .filter(Boolean)
    .map((part, index) =>
      index === 0 ? part : part.charAt(0).toUpperCase() + part.slice(1),
    )
    .join("")

const firstErrorMessage = value => {
  if (Array.isArray(value)) {
    return value.find(item => typeof item === "string" && item.trim()) || ""
  }
  return typeof value === "string" ? value : ""
}

/**
 * Laravel-style `errors: { field: ["msg"] }` → form field map.
 */
export const getApiFieldErrors = (error, fieldMap = {}) => {
  const data = error?.response?.data || error?.data || error
  const apiErrors = data?.errors
  if (!apiErrors || typeof apiErrors !== "object" || Array.isArray(apiErrors)) {
    return {}
  }

  const result = {}
  Object.entries(apiErrors).forEach(([key, value]) => {
    const message = String(firstErrorMessage(value) || "").trim()
    if (!message) return
    const mapped = fieldMap[key] || fieldMap[toCamelCase(key)] || toCamelCase(key)
    if (mapped) result[mapped] = message
  })
  return result
}

export const applyApiErrorsToForm = (formHelpers, error, fieldMap = {}) => {
  if (!formHelpers) return false
  const { setFieldError, setFieldTouched, setErrors } = formHelpers
  const hasFormik =
    typeof setErrors === "function" || typeof setFieldError === "function"
  if (!hasFormik) return false

  const fieldErrors = getApiFieldErrors(error, fieldMap)
  const keys = Object.keys(fieldErrors)
  if (!keys.length) return false

  if (typeof setErrors === "function") {
    setErrors(fieldErrors)
  }
  keys.forEach(key => {
    if (typeof setFieldError === "function") {
      setFieldError(key, fieldErrors[key])
    }
    if (typeof setFieldTouched === "function") {
      setFieldTouched(key, true, false)
    }
  })
  return true
}

export const applyApiErrorsToState = (setFieldErrors, error, fieldMap = {}) => {
  if (typeof setFieldErrors !== "function") return false
  const fieldErrors = getApiFieldErrors(error, fieldMap)
  if (!Object.keys(fieldErrors).length) return false
  setFieldErrors(prev => ({ ...(prev || {}), ...fieldErrors }))
  return true
}

/**
 * Prefer inline field errors; toast only when the API has no per-field errors.
 */
export const reportFormApiError = (
  error,
  fallback,
  formHelpers,
  fieldMap = {},
) => {
  if (applyApiErrorsToForm(formHelpers, error, fieldMap)) return true
  if (applyApiErrorsToState(formHelpers?.setFieldErrors, error, fieldMap)) {
    return true
  }
  toastApiError(error, fallback)
  return false
}
